import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
    showMark?: boolean
}

export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <span aria-hidden='true' className={cn('font-display text-[1.9rem] leading-none font-semibold tracking-tight text-primary', className)}>
            AD
        </span>
    )
}

const Logo: FC<LogoProps> = ({ className, tone = 'dark' }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3 select-none', className)}>
            <LogoMark />
            <span className={cn('relative pb-1 text-[0.85rem] font-semibold tracking-[0.45em] uppercase', tone === 'light' ? 'text-ink-foreground' : 'text-foreground')}>
                Artdoors
                <span className='ad-underline-fade absolute inset-x-0 bottom-0 h-0.5 bg-primary' aria-hidden='true' />
            </span>
        </span>
    )
}

export default Logo
